module App.DispatchSummary {
	angular
		.module('dispatchSummary', [])
		.factory('DispatchSummaryService', DispatchSummaryService.factory())
		.controller('DispatchSummaryController', DispatchSummaryController);
}